module.exports = __webpack_public_path__ + "img/syukyaku-kaisya-003.48b97090.jpg";